import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import type { LoginCredentials, RegisterData, User } from '@/types/auth'
import type { ComputedRef, Ref } from 'vue'

export interface UseAuthReturn {
  user: Ref<User | null>
  isAuthenticated: ComputedRef<boolean>
  isLoading: Ref<boolean>
  login: (_loginCredentials: LoginCredentials) => Promise<void>
  register: (_registerData: RegisterData) => Promise<void>
  logout: () => Promise<void>
  refreshUser: () => Promise<void>
}

export const useAuth = (): UseAuthReturn => {
  const authStore = useAuthStore()
  const { user, isAuthenticated, isLoading } = storeToRefs(authStore)

  const login = async (loginCredentials: LoginCredentials): Promise<void> => {
    await authStore.login(loginCredentials)
  }

  const register = async (registerData: RegisterData): Promise<void> => {
    await authStore.register(registerData)
  }

  const logout = async (): Promise<void> => {
    await authStore.logout()
  }

  const refreshUser = async (): Promise<void> => {
    await authStore.refreshUser()
  }

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    register,
    logout,
    refreshUser
  }
}
